<template>
  <div class="app flex-row align-items-center" :class="note" :style="note">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-6">
            <b-card-body class="p-4">
              <b-form>
                <h4>{{$t("common.reset_pwd")}}</h4>
                <b-input-group class="mb-2 mt-2">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="oldpassword" type="password" class="form-control" style="font-size: 1rem"
                    :placeholder="$t('common.old_pwd')" v-model="registerModel.oldpassword" @keyup.enter="nextInput(1)"
                    autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');this.type='password'"
                    onblur="this.setAttribute('readonly',true);" />
                </b-input-group>
                <b-input-group class="mb-2">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="newpassword" type="password" class="form-control" style="font-size: 1rem"
                    :placeholder="$t('common.new_pwd')" v-model="registerModel.newpassword" @keyup.enter="nextInput(2)"
                    autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');this.type='password'"
                    onblur="this.setAttribute('readonly',true);" />
                </b-input-group>
                <b-input-group class="mb-2">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="repassword" autocomplete="off" type="password" class="form-control" :placeholder="$t('common.confirm_pwd')"
                    style="font-size: 1rem" v-model="registerModel.repassword" @keyup.enter="resetPwd" @change="ChkPassword" />
                </b-input-group>

                <b-row>
                  <b-col cols="6">
                    <b-button block variant="primary" class="px-4" @click="resetPwd">{{$t("common.commit")}}</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right" v-if="!isOnline">
                    <b-button block variant="warning" class="px-4 ml-1" @click="onReset">{{$t("common.goto_login")}}</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right" v-if="isOnline">
                    <b-button block class="px-4 ml-1" @click="onCancel">{{$t("common.cancel")}}</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
            <!-- <b-card-footer class="p-4">
              <b-row>
                <b-col cols="12">
                  <p>asdfsdfasdfsadfasd</p>
                </b-col>
              </b-row>
            </b-card-footer>-->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import apiPath from "../../shared/apiPath";
import * as api from "../../shared/api";
export default {
  name: "Register",
  props: {
    isOnline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      note: {
        backgroundImage:
          "url(" + require("../../../public/img/pattern.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      },
      action: "注册",
      get_sms_disabled: true,
      captcha: "",
      mobile: "",
      sms_num: "",
      url: "",
      password: "",
      redirect: "",
      refer_idx: "",
      is_reset_password: 1,

      tooltipShow: false,
      registerModel: {
        oldpassword: "",
        newpassword: "", //密码
        repassword: "", //重复密码
      },
    };
  },
  created() { },
  mounted() { },
  methods: {
    nextInput(flag) {
      switch (flag) {
        case 1:
          this.$refs.newpassword.focus();
          break;
        case 2:
          this.$refs.repassword.focus();
          break;

        default:
          return;
      }
      this.$refs.userpassword.focus();
    },
    async resetPwd() {
      if (!this.ChkPassword()) {
        return;
      }
      let _this = this;
      let _p = new FormData();
      _p.append("oldPwd", _this.registerModel.oldpassword);
      _p.append("newPwd", _this.registerModel.newpassword);
      let result = await api.query_async({
        url: apiPath.user.reset_pwd,
        parameters: _p,
        method: "post",
      });
      //
      if (result && result[0].result.data) {
        let _result = result && result[0].result.data;
        if (_result.Result.success) {
          _this.msgToasts(this.$t("notify.pwd_reset_success"), "success");
          //返回登录重新登录
          window.location.href = "/pages/Login"
          //_this.$emit("closeResetPwdModal");
        } else {
          _this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        }
      } else {
        _this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
      }
    },
    ChkPassword() {
      let _this = this;
      if (_this.registerModel.newpassword != _this.registerModel.repassword) {
        _this.msgToasts(this.$t("notify.confirm_pwd_error"), "error");
        _this.$refs.newpassword.focus();
        return false;
      }
      if (
        _this.registerModel.newpassword == "" ||
        _this.registerModel.repassword == "" ||
        _this.registerModel.oldpassword == ""
      ) {
        _this.msgToasts(this.$t("notify.pwd_not_null"), "error");
        _this.$refs.newpassword.focus();
        return false;
      }
      return true;
    },
    onReset(evt) {
      this.$router.push({ path: "/pages/login" });
    },
    onCancel() {
      this.$emit("closeResetPwdModal");
    },
  },
};
</script>
<style scoped>
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #666;
  font-size: 15px;
}
</style>
